import * as React from 'react';
import { observer } from 'mobx-react';
import { BreathingSession } from '../../../Model/Explore/BreathingSession';
import { BreathingSoundsAndAnimations } from './BreathingSoundsAndAnimations';
import { useLocalizedImage } from '../../../Hooks/useLocalizedMedia';
import { getMediaLargeOrMediumOrSmallestUriObject } from '../../../Model/Media/Media';

export type BreathingExerciseProgressProps = {
  activeSession: BreathingSession;
  onStart?: () => void;
  onStop?: () => void;
};

export const BreathingExerciseProgress: React.FC<BreathingExerciseProgressProps> = observer(
  ({ activeSession, onStart, onStop }) => {
    const animatedSequence = activeSession.entry.technique.map((t) => ({
      type: t.type,
      duration: t.duration,
    }));

    const growTime = animatedSequence.find((t) => t.type === 'inhale')?.duration || 0;
    const holdTime = animatedSequence.find((t) => t.type === 'hold')?.duration || 0;
    const shrinkTime = animatedSequence.find((t) => t.type === 'exhale')?.duration || 0;

    const imageDefault = useLocalizedImage(activeSession.entry.images);
    const bgMedia = activeSession.entry.backgroundImage ?? imageDefault;
    const image = bgMedia ? getMediaLargeOrMediumOrSmallestUriObject(bgMedia).uri : undefined;

    const handleStop = React.useCallback(() => {
      activeSession.endSession();
      onStop?.();
    }, [activeSession, onStop]);

    return (
      <BreathingSoundsAndAnimations
        activeSession={activeSession}
        growTime={growTime}
        shrinkTime={shrinkTime}
        holdTime={holdTime}
        onStart={onStart}
        onStop={handleStop}
        backgroundImage={image}
      />
    );
  },
);
